import {Pipe, PipeTransform} from '@angular/core';

type FormatMode = 'ceil' | 'floor' | 'round' | 'none' | 'nearest' | 'toFixed' | 'halfUp' | 'precise';

@Pipe({
    name: 'DbNumberFormatPipe',
    standalone: true,
})

export class DbNumberFormatPipe implements PipeTransform {
    transform(value: number, mode: FormatMode = 'ceil', precision: number = 0): number {

      if (mode === 'precise') {
        // Custom behavior: floor if .4 or lower, ceil if .5 or higher
        let decimalPart = value - Math.floor(value); // Get the decimal part
        if (decimalPart >= 0.5) {
          return Math.ceil(value);
        } else {
          return Math.floor(value);
        }
      } else if (mode === 'nearest') {
            return Math.round(value * 2) / 2;
        } else if (mode === 'none') {
            return value;
        } else if (mode === 'toFixed') {
            return Number(value.toFixed(1));
        } else if (mode === 'halfUp') {
          let factor = Math.pow(10, precision);
          return Math.round(value * factor) / factor;
        } else return Math[mode](value);
    }
}
